import { IconButton, TableCell, TableRow, Tabs } from '@mui/material';
import { styled } from '@mui/system';

export const colors = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#AF19FF',
  '#FF3366',
  '#33CCFF'
];

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 14,
  color: '#333',
  fontWeight: 'bold',
  backgroundColor: '#F7F9FC',
  padding: '8px 12px',
  borderBottom: `1px solid ${theme.palette.divider}`
}));

export const HeaderTableCell = styled(StyledTableCell)(({ theme }) => ({
  backgroundColor: '#2596be',
  color: '#ffffff',
  fontWeight: 'bold',
  padding: '10px 16px'
}));

export const FirstColumnCell = styled(StyledTableCell)(({ theme }) => ({
  fontWeight: 'bold',
  backgroundColor: '#E3E6F0'
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#FAFAFA'
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#FFFFFF'
  },
  '&:hover': {
    backgroundColor: '#E0F7FA',
    cursor: 'pointer'
  }
}));

export const GenderButton = styled(IconButton)(({ theme, selected }) => ({
  backgroundColor: selected ? '#1976d2' : '#ffffff',
  color: selected ? '#ffffff' : '#333',
  marginRight: theme.spacing(1),
  '&:hover': {
    backgroundColor: selected ? '#115293' : '#f0f0f0'
  }
}));

export const StyledTabs = styled(Tabs)(({ theme }) => ({
  backgroundColor: '#f5f7fa',
  borderRadius: '8px',
  boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
  marginBottom: '10px'
}));
